export default __webpack_public_path__ + "4ea6e533cdd998cd9b9cee07526edfd5.png";